module.exports = __webpack_public_path__ + "img/GR056.529e7d80.png";